import { mapDonorDataPayload, mapDonorDataToOpoForm } from '@features/forms/DonorProfileForm';
import { EditDonorProfileFormValues } from './config';
import { OpoCase, UpdateDonorDataRequestBody } from '@/api/apis/case/opo-case';

// ---------------------------------------------------------------------------
// OpoCase.donorData → EditDonorProfileFormValues
// ---------------------------------------------------------------------------

export const mapOpoCaseDonorDataToFormValues = (
  opoCase: Pick<OpoCase, 'matchId' | 'donorData' | 'organType' | 'donorType'>,
): EditDonorProfileFormValues => ({
  ...mapDonorDataToOpoForm(opoCase.donorData, opoCase.organType, opoCase.matchId),
  organType: opoCase.organType,
  donorType: opoCase.donorType,
});

// ---------------------------------------------------------------------------
// EditDonorProfileFormValues → UpdateDonorDataRequestBody
// ---------------------------------------------------------------------------

export const mapFormValuesToOpoCaseDonorData = (values: EditDonorProfileFormValues): UpdateDonorDataRequestBody =>
  mapDonorDataPayload(values, values.organType);
